import { LegalLayout } from "@/components/legal/legal-layout";
import { parseLegalDocument } from "@/lib/legal-markdown";
import privacyPolicySource from "@/content/legal/privacy-policy.md?raw";

/**
 * This page renders a truthful current-state Privacy Policy for the public
 * website only (apps/web/src/content/legal/privacy-policy.md) — not the
 * internal comprehensive SaaS draft at docs/13-privacy-policy-draft.md,
 * which remains as future-state documentation and is never shipped to the
 * site. The current-state policy has no unresolved legal placeholders, so
 * there is nothing to flag via the "to be finalized" callout mechanism in
 * lib/legal-markdown.tsx.
 */
const PLACEHOLDER_MARKERS: string[] = [];

export function PrivacyPage() {
  const doc = parseLegalDocument(privacyPolicySource, PLACEHOLDER_MARKERS);

  return (
    <LegalLayout
      title="Privacy Policy"
      statusNote={doc.statusNote}
      lastUpdated={doc.lastUpdated}
      headings={doc.headings}
    >
      {doc.body}
    </LegalLayout>
  );
}
